import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import ColorScale from '_class/ColorScale';
import '../../Verdict.scss';

var VerdictLevelForm = /*#__PURE__*/function (_Component) {
  _inherits(VerdictLevelForm, _Component);

  var _super = _createSuper(VerdictLevelForm);

  function VerdictLevelForm(props) {
    var _this;

    _classCallCheck(this, VerdictLevelForm);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onCellClick", function (cell) {
      _this.setState({
        active: cell.id
      });

      if (_this.props.onChange) {
        _this.props.onChange(cell.id);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillReceiveProps", function (nextProps) {
      if (nextProps.value != _this.state.value) {
        _this.setState({
          active: nextProps.value
        });
      }
    });

    var active = null;

    if (props.value != null) {
      active = props.value;
    }

    _this.state = {
      active: active
    };
    return _this;
  }

  _createClass(VerdictLevelForm, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      if (this.props.levels == null) {
        return null;
      }

      var colors = new ColorScale(this.props.levels.length).get();
      return /*#__PURE__*/React.createElement("div", {
        className: "verdict verdict-level-form"
      }, /*#__PURE__*/React.createElement("div", {
        className: "verdict-cells"
      }, this.props.levels.map(function (cell) {
        var styles = {
          '--level-color': cell.colorCode != null ? cell.colorCode : colors[cell.level]
        };
        var className = "cell";

        if (cell.id == _this2.state.active) {
          className += ' active';
        }

        return /*#__PURE__*/React.createElement("div", {
          key: cell.id,
          style: styles,
          className: className,
          onClick: function onClick(e) {
            return _this2.onCellClick(cell);
          }
        }, cell.localizationText != null ? cell.localizationText : cell.level);
      })));
    }
  }]);

  return VerdictLevelForm;
}(Component);

export default VerdictLevelForm;